export function toFixed(num: number, fixed = 2): number {
    return +parseFloat(`${num}`).toFixed(fixed);
}
